import { render, staticRenderFns } from "./DependenciesDirectory.vue?vue&type=template&id=79d9fcb3"
import script from "./DependenciesDirectory.vue?vue&type=script&lang=js"
export * from "./DependenciesDirectory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports